module.exports = {
  "/": {},
  "/:knowledgeBaseId": {},
  "/:knowledgeBaseId/articles": {},
  "/:knowledgeBaseId/articles/state": {},
  "/articles/state/:state": {},
  "/:knowledgeBaseId/articles/state/:state": {
    "name": "articleManagement",
    "success": {
      "default": [
        "MANAGE_LOAD"
      ]
    },
    "error": [
      "MANAGE_ERROR"
    ]
  },
  "/:knowledgeBaseId/organize": {
    "name": "categoryManagement",
    "success": {
      "default": [
        "ORGANIZE_LOAD"
      ]
    }
  },
  "/insights/dashboard": {},
  "/:knowledgeBaseId/insights/dashboard": {
    "success": {
      "onboarding": [
        "ONBOARDING_LOAD"
      ],
      "dashboard": [
        "DASHBOARD_LOAD"
      ]
    },
    "error": [
      "DASHBOARD_ERROR"
    ]
  },
  "/:knowledgeBaseId/customize-template": {},
  "/:knowledgeBaseId/customize-template/:tabName": {
    "name": "legacyThemeEditor",
    "success": {
      "template editor sidebar loaded": [
        "TEMPLATE_EDITOR_SIDEBAR_LOAD"
      ],
      "template editor preview loaded": [
        "TEMPLATE_EDITOR_PREVIEW_LOAD"
      ]
    }
  },
  "/:knowledgeBaseId/customize-template/content/:item": {
    "name": "legacyThemeEditorSection",
    "success": {
      "template editor sidebar loaded": [
        "TEMPLATE_EDITOR_SIDEBAR_LOAD"
      ],
      "template editor preview loaded": [
        "TEMPLATE_EDITOR_PREVIEW_LOAD"
      ]
    }
  },
  "/edit/:articleId": {
    "name": "legacyArticleEditor",
    "success": {
      "default": [
        "ARTICLE_EDITOR_LOAD"
      ]
    }
  },
  "/insights/article/:articleId": {},
  "/insights/article/:articleId/performance": {
    "success": {
      "article performance": [
        "ARTICLE_PERFORMANCE_LOAD"
      ],
      "not found": [
        "ARTICLE_DETAILS_NOT_FOUND"
      ]
    }
  },
  "/insights/article/:articleId/published": {
    "success": {
      "article published": [
        "ARTICLE_PUBLISHED_LOAD"
      ]
    }
  }
};